import React, { useEffect } from 'react';
import { StyledModularReeditBanner, StyledModularReeditBannerHeader, StyledModularReeditBannerPadding } from './styles';
import useModulerEnrolmentContext from '../../pages/SPAContainer/pages/ModularEnrolmentPage/ModulerEnrolmentContext';
import { InfoIcon } from '../../../assets/img/CustomIcons';
import theme from '../../../theme';
import { Typography } from '@loophealth/loop-ui-web-library';

const ModularReeditBanner: React.FC = () => {
    const bannerRef = React.useRef<HTMLDivElement>(null);
    const [padding, setPadding] = React.useState(80);
    const { isReeditMode } = useModulerEnrolmentContext();

    useEffect(() => {
        if (!bannerRef.current) return;
        const handleResize = () => {
            console.log('Resizing banner');
            const bannerHeight = bannerRef.current?.offsetHeight || 80;
            setPadding(bannerHeight);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [bannerRef.current]);

    return isReeditMode ? (
        <>
            <StyledModularReeditBanner ref={bannerRef}>
                <StyledModularReeditBannerHeader>
                    <InfoIcon strokeColor={theme.colors.planRed} />
                    <Typography variant="medium" weight="semiBold" color="planRed">
                        You&apos;re in Edit Mode
                    </Typography>
                </StyledModularReeditBannerHeader>
                <Typography variant="small">
                    Your updates will be saved as you go, but you must complete and submit on the final summary page. If
                    you exit early, your previous registration will remain final.
                </Typography>
            </StyledModularReeditBanner>
            <StyledModularReeditBannerPadding $padding={padding} />
        </>
    ) : null;
};

export default ModularReeditBanner;
